<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M466.7 489.3L150.7 173.3C116.6 212.6 96 263.9 96 320C96 443.7 196.3 544 320 544C376.1 544 427.4 523.4 466.7 489.3zM489.3 466.7C523.4 427.4 544 376.1 544 320C544 196.3 443.7 96 320 96C263.9 96 212.6 116.6 173.3 150.7L489.3 466.7zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320z"
      fill="currentColor"
    />
  </svg>
</template>
